import AssetHelper from "ftc-common/AssetHelper";
import { FllScoreCalculator } from "./FllScoreCalculator";
import { createRoot } from "react-dom/client";

declare global {
    interface Window {
        supportedLangs: Record<string, string>;
        lang: string;
    }
}

/*
 * Served at /fll/score-calculator — no authentication required, and rendered via
 * ReactHandler.buildRaw so no Cloud navbar/login chrome loads. The calculator
 * carries its own language dropdown, fed by window.supportedLangs / window.lang.
 */
AssetHelper.ensureProperties().then(() => {
    const container = document.getElementById("reactContainer");
    if (container) {
        const root = createRoot(container);
        root.render(<FllScoreCalculator />);
    } else {
        console.error("Container element not found");
    }
});

